import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { EventiService } from './eventi.service';
import { catchError, finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EntiDelegatiDatasource implements DataSource<ModelEventiCalamitosi.EntiDelegatiEventoDTO> {
  public entiDelegatiSubject = new BehaviorSubject<ModelEventiCalamitosi.EntiDelegatiEventoDTO[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  private errorSubject = new BehaviorSubject<boolean>(false);
  public errors$ = this.errorSubject.asObservable();
  isLoading: boolean = false;
  errorMessage: string = null;
  private countSubject = new BehaviorSubject<number>(0);
  public counter$ = this.countSubject.asObservable();

  constructor(private eventiService: EventiService) { }

  public getEntiDelegatiList(
    filter: {
      idEvento: number,
      page: number,
      size: number,
      sort: string,
      idEnte: string,
      description: string,
    }
  ): void {
    this.loadingSubject.next(true);
    this.eventiService.getEntiDelegatiList(filter)
      .pipe(
        catchError(err => {
          this.errorSubject.next(true);
          return throwError(err);
        }),
        catchError(err => {
          console.error(err);
          return of([]);
        }),
        finalize(() => {
          this.loadingSubject.next(false);
        })
      )
      .subscribe(result => {
        //console.log(result['content'])
        this.entiDelegatiSubject.next(result['content']);
        this.countSubject.next(result['totalElements']);
      }
      );
  }

  connect(collectionViewer: CollectionViewer): Observable<ModelEventiCalamitosi.EntiDelegatiEventoDTO[]> {
    return this.entiDelegatiSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.entiDelegatiSubject.complete();
    this.loadingSubject.complete();
  }
}
